module.exports = __webpack_public_path__ + "static/druid-010ca2b0612a2caed075a2027597bbd5.jpg";